import { useState } from 'react';
import { useRecoilValue } from 'recoil';

import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import Modal from '@Components/Shared/Modals/Modal';
import Toggle from '@Components/Shared/Controls/Toggle';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { LinkRelationTypes } from '@Components/Utilities/SandhillsConstants';

const ListingOptions = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showAllSpecs, setShowAllSpecs] = useState(props.showAllSpecs);
    const [showFullDescription, setShowFullDescription] = useState(props.showFullDescription);
    const routes = useRecoilValue(atoms.routes);
    const currentSite = useRecoilValue(atoms.currentWebsite);

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => setIsModalOpen(false);

    const toggleAllSpecs = () => {
        const newShowAllSpecs = !showAllSpecs;
        setShowAllSpecs(newShowAllSpecs);

        sandhillsRequest({
            url: routes.SaveListingsPageOptionsShowAllSpecs,
            method: 'post',
            data: {
                showAllSpecs: newShowAllSpecs
            }
        }).then((data) => {
            if (data) {
                props.setShowAllSpecs(newShowAllSpecs);
            }
        }).catch((error) => {

        });
    }

    const toggleFullDescription = () => {
        const newShowFullDescription = !showFullDescription;
        setShowFullDescription(newShowFullDescription);

        sandhillsRequest({
            url: routes.SaveListingsPageOptionsShowFullDescription,
            method: 'post',
            data: {
                showFullDescription: newShowFullDescription
            }
        }).then((data) => {
            if (data) {
                props.setExpandAllDescriptions(newShowFullDescription);
            }
        }).catch((error) => {

        });
    }

    return (
        <>
            {!currentSite?.Site?.IsHostedSite &&
                <div
                    className="option-modal-button"
                    role='button'
                    tabIndex='0'
                    onClick={handleOpenModal}
                    onKeyPress={e => { if (e.key === 'Enter' || e.key === ' ') handleOpenModal(); }}
                >
                    <i className='fa-solid fa-gear' />
                    <TranslationText tKey='sandhills.crm.dscrm.options' />
                </div>
            }
            {isModalOpen &&
                <Modal containerClassName='' onEscapeKeyClose={handleCloseModal}>
                    <Modal.Header onClose={handleCloseModal}>
                        <Modal.Title>
                            {translator.translate('sandhills.listing')} {translator.translate('sandhills.crm.dscrm.options')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {props.IsAuthenticated ?
                            <div className="modal-main">
                                <div className='option-modal-row'>
                                    <div className='option-modal-label'><label htmlFor={'showAllSpecs'}>{translator.translate('sandhills.tradepubwebsite.mvc.showall')} {translator.translate('sandhills.specs')}</label></div>
                                    <div className='toggle'>
                                        <Toggle
                                            classNames=''
                                            id={'showAllSpecs'}
                                            IsChecked={showAllSpecs}
                                            onChange={() => toggleAllSpecs()}
                                        />
                                    </div>
                                </div>
                                <div className='option-modal-row'>
                                    <div className='option-modal-label'><label htmlFor={'showFullDescription'}>{translator.translate('sandhills.tradesites.mvc.showfulldescriptionupto')}</label></div>
                                    <div className='toggle'>
                                        <Toggle
                                            classNames=''
                                            id={'showFullDescription'}
                                            IsChecked={showFullDescription}
                                            onChange={() => toggleFullDescription()}
                                        />
                                    </div>
                                </div>
                            </div>
                            :
                            <span style={{ fontSize: '14px', paddingBottom: '10px', display: 'inline-block' }}><TranslationText tKey='sandhills.tradesites.mvc.logintocustomizelistingdisplayoptions' /></span>
                        }
                        <div className='form-bottom'>
                            {props.IsAuthenticated ?
                                <button
                                    className='ts-button button listings-options-submit-button'
                                    aria-label={translator.translate('sandhills.tradepubwebsite.mvc.close')}
                                    onClick={handleCloseModal}
                                >
                                    <TranslationText tKey='sandhills.tradepubwebsite.mvc.close' />
                                </button>
                                :
                                <a className='ts-button recaptcha-submit-button button listings-options-submit-button' href={routes.FullRegistrationRoute} rel={LinkRelationTypes.noFollow}>{translator.translate('Sandhills.TradePubWebSite.MVC.LogIn')} {translator.translate('sandhills.now')}</a>
                            }
                        </div>
                    </Modal.Body>
                </Modal>
            }
        </>
    );
};

export default ListingOptions;